module.exports = __webpack_public_path__ + "static/img2-510f41c12b16021c0ad1c3ace2d10d45.png";